/* eslint-disable */

import React from 'react';

export default function WireframeHeaderMobile(props: {
    check24Domain: string;
    href: string;
    loginStatus: 'active' | 'expired' | 'guest' | 'loggedout';
    username: string | null;
    assetComponent: React.ReactNode;
    contactLayerComponent: React.ReactNode;
    navigationComponent: React.ReactNode;
    menuButtonVisible: boolean;
    onClickMenuButton: () => void;
    onWireframeBack: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
    titleComponent: React.ReactNode;
    wireframeBackUrl: string;
    wireframeBackVisible: boolean;
}) {
    // @ts-ignore - not used in all components
    const trailingQuestionmarkRegex = new RegExp('\\?\\$');

    return (
        <>
            {props.assetComponent}
            <style
                jsx
                global
            >{`
                .header-inline-style-0 {
                    fill: #b4b4b4 !important;
                }

                .header-inline-style-1 {
                    position: absolute !important;
                    left: -9999px !important;
                    width: 1px !important;
                    height: 1px !important;
                }

                .c24m-contact-slogan {
                    padding: 0 !important;
                }
                .c24m-header-back-wrapper {
                    display: ${props.wireframeBackVisible ? 'block' : 'none'} !important;
                }
                .c24m-nav-button {
                    display: ${props.menuButtonVisible ? 'block' : 'none'} !important;
                }
                .hits-suggest-phraselink {
                    pointer-events: none;
                }
                .hits-takeover-arrow {
                    padding: 24px;
                }
                input[type='text'].c24m-input {
                    font-size: 16px !important;
                }
                .c24m-contact-layer {
                    z-index: var(--z-index-wireframeContactLayer);
                }
                #c24m-header {
                    z-index: var(--z-index-wireframeMobileHeader) !important;
                }
                /** how to test: Open Contact Layer -> map button should be below blocking layer */
                #c24m-page-blocking-layer {
                    z-index: var(--z-index-wireframeBlockingLayer);
                    bottom: -1px;
                }
            `}</style>
            <header data-nosnippet="true">
                <div
                    id="c24m-header"
                    className={`c24m-search-slim `}
                >
                    <div id="c24m-header-blocking-layer"></div>
                    <div id="c24m-header-top">
                        <div className={`c24m-header-top-icons-left`}>
                            <a
                                className={`c24m-header-back-wrapper`}
                                href={`${props.wireframeBackUrl}`}
                                onClick={props.onWireframeBack}
                            >
                                <span className={`c24m-header-back`}>
                                    <svg
                                        version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        x="0px"
                                        y="0px"
                                        viewBox="0 0 58.2 100"
                                        xmlSpace="preserve"
                                    >
                                        <polygon
                                            fill="#FFFFFF"
                                            points="16.4,50 58.2,8.2 50,0 0,50 50,100 58.2,91.8 "
                                        ></polygon>
                                    </svg>
                                </span>
                            </a>
                            <nav>
                                <div id="c24m-nav">
                                    <div
                                        id="c24m-nav-button"
                                        className={`c24m-nav-button c24m-header-icon`}
                                        onClick={props.onClickMenuButton}
                                    >
                                        <div className={`c24m-nav-button-wrapper`}>
                                            <div className={`c24m-nav-burger`}>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 19"
                                                >
                                                    <path
                                                        fill="#fff"
                                                        d="M24 17.5c0 .8-.7 1.5-1.6 1.5H1.6C.7 19 0 18.3 0 17.5v-.1c0-.7.7-1.4 1.6-1.4h20.7c1 0 1.7.6 1.7 1.5zm0-8c0 .8-.7 1.5-1.6 1.5H1.6C.7 11 0 10.3 0 9.5S.7 8 1.6 8h20.7c1 0 1.7.7 1.7 1.5zm0-8c0 .8-.7 1.5-1.6 1.5H1.6C.7 3 0 2.4 0 1.6v-.1C0 .7.7 0 1.6 0h20.7c1 0 1.7.7 1.7 1.5z"
                                                    ></path>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="c24m-nav-slide">{props.navigationComponent}</div>
                                </div>
                            </nav>
                            {(props.loginStatus === 'guest' || props.loginStatus === 'loggedout') && (
                                <div className={`c24m-customer c24m-customer-guest c24-uliloginlayer-login-opener`}>
                                    <span className={`c24m-customer-icon c24m-customer-icon-lo`}></span>
                                </div>
                            )}
                            {props.loginStatus === 'active' && (
                                <a
                                    className={`c24m-customer c24m-customer-user`}
                                    href={`https://m.check24.de/kundenbereich/?o=overview`}
                                >
                                    <span className={`c24m-customer-icon c24m-customer-icon-li`}></span>
                                </a>
                            )}
                            {props.loginStatus === 'expired' && (
                                <div className={`c24m-customer c24m-customer-expired c24-uliloginlayer-login-opener`}>
                                    <span className={`c24m-customer-icon c24m-customer-icon-li`}></span>
                                </div>
                            )}{' '}
                        </div>
                        {props.titleComponent}
                        <div className={`c24m-header-top-icons-right`}>
                            <div
                                className={`c24m-contact-wrapper c24m-header-icon clearfix`}
                                data-qa-id="qa-wireframe-contact"
                            >
                                <div className={`c24m-contact-icon`}></div>
                                <div className={`c24m-contact-layer`}>
                                    <div className={`c24m-contact-layer-corner`}></div>
                                    <div className={`c24m-contact-layer-close`}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlSpace="preserve"
                                            viewBox="0 0 100 100"
                                            y="0px"
                                            x="0px"
                                            version="1.1"
                                            className={`c24m-navi-header-close`}
                                        >
                                            <polygon
                                                fill="#b4b4b4"
                                                points="89.7,0 50,39.6 10.3,0 0,10.3 39.6,50 0,89.7 10.3,100 50,60.4 89.7,100 100,89.7 60.4,50 100,10.3"
                                            ></polygon>
                                        </svg>
                                    </div>
                                    <div
                                        className={`c24m-contact-layer-content-wrapper`}
                                        id="chatty-chatbot-layer"
                                    >
                                        <div className={`c24m-contact-slogan`}>
                                            <span></span>
                                        </div>
                                        <div className={`c24m-contact-layer-content`}>
                                            {props.contactLayerComponent}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={`c24m-search-icon-wrapper c24m-header-icon`}>
                                <div className={`c24m-search-icon`}></div>
                            </div>
                        </div>
                    </div>
                    <div id="c24-header-bottom">
                        <div className={`c24m-header-content clearfix`}>
                            <div
                                id="c24m-search"
                                className={`clearfix`}
                            >
                                <div className={`c24m-search-content`}>
                                    <form
                                        action="https://m.check24.de/suche/"
                                        method="GET"
                                        id="c24m-search-form"
                                        spellCheck="false"
                                    >
                                        <fieldset>
                                            <div
                                                className={`clearfix`}
                                                id="c24m-searchcontainer"
                                            >
                                                <input
                                                    type="text"
                                                    className={`c24m-input`}
                                                    id="c24m-sitesearch-suggester"
                                                    autoComplete="off"
                                                    placeholder="Was m&ouml;chten Sie vergleichen?"
                                                    name="q"
                                                    defaultValue=""
                                                    data-clear-btn="true"
                                                />
                                                <input
                                                    type="hidden"
                                                    name="source"
                                                    id="source_suggest"
                                                    defaultValue="input"
                                                />
                                                <div className={`c24m-search-button`}>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 100 100"
                                                        xmlSpace="preserve"
                                                    >
                                                        <path
                                                            fill="#999999"
                                                            d="M64.8,14.1C52.6-1.7,29.9-4.6,14.1,7.5S-4.6,42.4,7.5,58.2c11,14.2,30.3,17.9,45.6,9.9L77,99
                                        c0.9,1.2,2.6,1.4,3.6,0.5l5.5-4.2c1.2-0.9,1.4-2.6,0.5-3.6L62.8,60.8C74.5,48,75.8,28.2,64.8,14.1z M52.9,57.8
                                        c-11.9,9.2-29.1,7-38.3-5c-9.3-11.9-7-29.1,5-38.3c11.9-9.3,29.1-7,38.3,5C67.1,31.4,64.8,48.5,52.9,57.8z"
                                                        ></path>
                                                    </svg>
                                                </div>
                                                <div className={`c24m-search-clear`}>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlSpace="preserve"
                                                        viewBox="0 0 100 100"
                                                        y="0px"
                                                        x="0px"
                                                        version="1.1"
                                                    >
                                                        <polygon
                                                            points="89.7,0 50,39.6 10.3,0 0,10.3 39.6,50 0,89.7 10.3,100 50,60.4 89.7,100 100,89.7 60.4,50 100,10.3"
                                                            className={`header-inline-style-0`}
                                                        ></polygon>
                                                    </svg>
                                                </div>
                                                <input
                                                    type="submit"
                                                    tabIndex={-1}
                                                    className={`header-inline-style-1`}
                                                />
                                            </div>
                                        </fieldset>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
}
